<script lang="ts">
  import ChevronLeftIcon from "../utils/assets/chevron_left_icon.svelte";
  import AddIcon from "../utils/assets/add_icon.svelte";
  import CrossIcon from "../utils/assets/cross_icon.svelte";
  import { toggleWidget } from "../stores/app";
  import {
    detectBot,
    selected_communication,
    is_new_chat_loading,
    showSocketLoader,
  } from "../stores/chat";
  import LanguageSelectionDropdown from "./LanguageSelectionDropdown.svelte";
  import { client_config } from "../stores/store";
  import { client_id } from "../stores/chat";

  export let accentColor = "#007AFF";
  export let showBackButton = true;
  export let onStartNewChat: () => Promise<void>;

  const isYpp = $client_id === "ypp";

  let titleEl: HTMLHeadingElement;
  let showTitleTooltip = false;
  let isTitleTruncated = false;

  const handleTitleEnter = () => {
    isTitleTruncated = titleEl
      ? titleEl.scrollWidth > titleEl.clientWidth
      : false;
    showTitleTooltip = true;
  };

  const handleTitleLeave = () => {
    showTitleTooltip = false;
  };

  const startNewConversation = async () => {
    if (!$is_new_chat_loading && !$showSocketLoader) {
      is_new_chat_loading?.set(true);
      await onStartNewChat();
      await detectBot();
      is_new_chat_loading?.set(false);
    }
  };
</script>

<div
  style="--accent-color: {accentColor} !important;"
  class="verbaflo-widget-header"
>
  <div class="verbaflo-widget-header-container">
    <div class="verbaflo-widget-left-container">
      {#if showBackButton}
        <button
          type="button"
          class="verbaflo-widget-back-btn"
          on:click={toggleWidget}
        >
          <ChevronLeftIcon />
        </button>
      {/if}
      <img
        src={$client_config?.client_logo_url ||
          "https://vf-assets.verbaflo.com/logo.png"}
        alt="logo"
        style={isYpp ? "background-color: white !important;" : null}
        class="verbaflo-widget-client-logo"
      />
      <div class="verbaflo-widget-title-container">
        <div class="verbaflo-widget-title-wrapper">
          <h2
            bind:this={titleEl}
            class="verbaflo-widget-chat-title"
            on:mouseenter={handleTitleEnter}
            on:mouseleave={handleTitleLeave}
          >
            {$client_config?.header_name || "Verbaflo"}
          </h2>
          {#if showTitleTooltip && isTitleTruncated}
            <div class="verbaflo-widget-title-tooltip">
              {$client_config?.header_name || "Verbaflo"}
            </div>
          {/if}
        </div>
        <div class="verbaflo-widget-status">
          <span class="verbaflo-widget-status-dot"></span>
          <span class="verbaflo-widget-status-text">
            {$client_config?.online_text || "Online"}
          </span>
        </div>
      </div>
    </div>
    <div class="verbaflo-widget-right-container">
      {#if ($client_config?.languages?.other_languages?.length > 0 || $client_config?.languages?.popular_languages?.length > 0) && $selected_communication === "message"}
        <LanguageSelectionDropdown languages={$client_config?.languages} />
      {/if}

      <button
        type="button"
        on:click={startNewConversation}
        class="verbaflo-widget-new-chat-btn"
        disabled={$is_new_chat_loading || $showSocketLoader}
      >
        <AddIcon color="white" size="16" />
        <span class="verbaflo-widget-new-chat-label">New Chat</span>
      </button>

      <button
        type="button"
        on:click={toggleWidget}
        class="verbaflo-widget-close-btn"
        aria-label="Close chat"
      >
        <CrossIcon color="white" size="18" />
      </button>
    </div>
  </div>
</div>

<style>
  :global(#vfwidget .verbaflo-widget-header) {
    background-color: var(--accent-color) !important;
    border-top-left-radius: 24px !important;
    border-top-right-radius: 24px !important;
    height: 52px !important;
    display: flex !important;
    align-items: center !important;
    padding: 0 12px !important;
    position: relative !important;
    flex-shrink: 0 !important;
  }

  :global(#vfwidget .verbaflo-widget-header-container) {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    width: 100% !important;
    height: 100% !important;
    box-sizing: border-box !important;
  }

  :global(#vfwidget .verbaflo-widget-left-container) {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    min-width: 0 !important;
  }

  :global(#vfwidget .verbaflo-widget-back-btn) {
    display: none !important;
    background: none !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    cursor: pointer !important;
  }

  :global(#vfwidget .verbaflo-widget-back-btn:hover) {
    background-color: transparent !important;
    opacity: 1 !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-back-btn:active) {
    background-color: transparent !important;
    opacity: 1 !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-client-logo) {
    width: 24px !important;
    height: 24px !important;
    border-radius: 50% !important;
    object-fit: cover !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    margin-left: 8px !important;
  }

  :global(#vfwidget .verbaflo-widget-title-container) {
    display: flex !important;
    flex-direction: column !important;
    margin-left: 8px !important;
    min-width: 0 !important;
  }

  :global(#vfwidget .verbaflo-widget-title-wrapper) {
    position: relative !important;
    min-width: 0 !important;
    max-width: 100% !important;
  }

  :global(#vfwidget .verbaflo-widget-title-tooltip) {
    position: absolute !important;
    top: calc(100% + 6px) !important;
    left: 0 !important;
    z-index: 999999 !important;
    background-color: #ffffff !important;
    color: #000000 !important;
    padding: 6px 10px !important;
    border-radius: 8px !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    line-height: 14px !important;
    white-space: nowrap !important;
    max-width: 240px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    pointer-events: none !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  }

  :global(#vfwidget .verbaflo-widget-chat-title) {
    color: white !important;
    margin: 0 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    padding: 0px !important;
    text-transform: none !important;
    font-weight: 400 !important;
    letter-spacing: 0.05em !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    max-width: 100% !important;
  }

  :global(#vfwidget .verbaflo-widget-status) {
    display: flex !important;
    align-items: center !important;
    gap: 4px !important;
  }

  :global(#vfwidget .verbaflo-widget-status-dot) {
    width: 9px !important;
    height: 9px !important;
    background-color: #039855 !important;
    border: 1.5px solid #d1fadf !important;
    border-radius: 50% !important;
    display: inline-block !important;
  }

  :global(#vfwidget .verbaflo-widget-status-text) {
    color: white !important;
    font-size: 10px !important;
    font-weight: 400 !important;
    margin: 0px !important;
    padding: 0px !important;
    line-height: 16px !important;
    text-transform: none !important;
  }

  :global(#vfwidget .verbaflo-widget-right-container) {
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
    flex-shrink: 0 !important;
  }

  :global(#vfwidget .verbaflo-widget-new-chat-btn) {
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
    background: rgba(255, 255, 255, 0.16) !important;
    border: none !important;
    border-radius: 9999px !important;
    padding: 5px 10px !important;
    outline: none !important;
    cursor: pointer !important;
  }

  :global(#vfwidget .verbaflo-widget-new-chat-btn:hover) {
    background: rgba(255, 255, 255, 0.28) !important;
    opacity: 1 !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-new-chat-btn:disabled) {
    opacity: 0.6 !important;
    cursor: default !important;
  }

  :global(#vfwidget .verbaflo-widget-new-chat-label) {
    color: white !important;
    font-size: 12px !important;
    font-weight: 400 !important;
    line-height: 16px !important;
    white-space: nowrap !important;
    text-transform: none !important;
  }

  :global(#vfwidget .verbaflo-widget-close-btn) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 28px !important;
    height: 28px !important;
    border-radius: 50% !important;
    background: rgba(255, 255, 255, 0.16) !important;
    border: none !important;
    padding: 0 !important;
    outline: none !important;
    cursor: pointer !important;
  }

  :global(#vfwidget .verbaflo-widget-close-btn:hover) {
    background: rgba(255, 255, 255, 0.28) !important;
    opacity: 1 !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-options-menu) {
    position: absolute !important;
    right: 0 !important;
    margin-top: 0 !important;
    padding: 8px 16px !important;
    display: flex !important;
    align-items: center !important;
    width: max-content !important;
    background: white !important;
    border: 1px solid #e5e7eb !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    border-radius: 8px !important;
    z-index: 50 !important;
    cursor: pointer !important;
    color: #4b5563 !important;
  }

  :global(#vfwidget .verbaflo-widget-options-menu:hover) {
    background-color: white !important;
    opacity: 1 !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-options-menu:active) {
    background-color: white !important;
    opacity: 1 !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-new-chat-text) {
    width: 100% !important;
    text-align: left !important;
    font-size: 14px !important;
    color: #4b5563 !important;
    padding: 4px !important;
    margin: 0 !important;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait),
    only screen and (max-height: 500px) and (orientation: landscape) {
    :global(#vfwidget .verbaflo-widget-header) {
      border-radius: 0 !important;
      height: 62px !important;
    }

    :global(#vfwidget .verbaflo-widget-back-btn) {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    :global(#vfwidget .verbaflo-widget-back-btn:hover) {
      background-color: transparent !important;
      opacity: 1 !important;
      text-decoration: none !important;
    }

    :global(#vfwidget .verbaflo-widget-back-btn:active) {
      background-color: transparent !important;
      opacity: 1 !important;
      text-decoration: none !important;
    }
  }
</style>
